import React, { useEffect, useState } from 'react'
import SearchContainer from './SearchContainer'
import WholesalerTable from './WholeSalersTable'
import { Card, CardBody, Container } from 'reactstrap'
import ErrorBoundary from 'components/ErrorBoundary'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useContextService from 'hooks/useContextService'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import useAxios from 'hooks/useAxios'
import { cloneDeep } from 'lodash'

const Wholsalers = (props) => {
  const { orgId,reset,tabKey } = props;
  const API = useAxios();

  const {
    states: { drugWholeSaler },
    setStates,
  } = useContextService();
  const { search, coveredEntity, searchTerms, claimStatusID } = drugWholeSaler;

  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [data, setData] = useState([]);
  const [totalitem, setTotalItem] = useState(0);
  const [columnFilters, setColumnFilters] = useState([]);
  const [accm,setAccm] = useState("");
  const [accuntErr, setAccountErr] = useState(false);
  const [resetFilterFlag, SetResetFilterFlag]= useState(false);

  useEffect(() => {
    if (searchTerms.coveredEntityID) handleSearch(searchTerms);
  }, []);

  useEffect(() => {
    handleReset();
  }, [orgId, reset]);
  
  const handleReset = () => {
    setcollapseSider(false);
    setAccountErr(false)
    setData([]);
    setTotalItem(0);
    SetResetFilterFlag(true);
  };
  

  const refetch = (value) => {
    setColumnFilters([]);
    drugWholeSaler.search.currentPage=1;
    search.AccumulatorID = value;
    fetchWholesalerAll(search)
  };

  const handleSearch = async (filter) => {
    debugger;
    const {
      accumulationIDs,
      accountTypeId
    } = filter;

    const tableRes = document.querySelector('.table-responsive');
    tableRes.scrollLeft = 0;

    search.AccumulatorID = accumulationIDs[0];
    setAccm(accumulationIDs[0]);
    search.AccountTypeID = parseInt(accountTypeId);
    await fetchWholesalerAll(search);
  };

  const fetchWholesalerAll = async (filters) => {
    debugger;
    if (!(orgId?.tenantID)) return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    try {
      if (filters.AccumulatorID > 0) {
        const { data } = await API.post(`SBTenant/${orgId.tenantID}/DrugCatalog/GetWholesalerAll`, filters,
          {
            hasDefaultURL: true,
          })
        if (data?.items?.length > 0) {
          setData(data.items);
          setCollIcon(faAngleDown);
          setTotalItem(data.totalRecords);
        } else {
          setData([]);
          setTotalItem(0);
        }
      }
    } catch (error) { }
    
  };



  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    }
    else {
      setCollIcon(faAngleUp);
    }
  }

  const handleExport = async () => {
    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
    onExport(action, initialFilters);
  };

  const handlePageChange = (filter, haveColFilter) => {
    updateWholeSalerSearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(search);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
       filterObj.orderBy= filter.orderBy;
        filterObj.order= filter.order;
  
      drugWholeSaler.search.currentPage = filter.currentPage;
      drugWholeSaler.search.pageSize = filter.pageSize;
      drugWholeSaler.search = { ...drugWholeSaler.search };
      fetchWholesalerAll(filterObj);

    } else {
      fetchWholesalerAll(filter);
      drugWholeSaler.search = { ...drugWholeSaler.search, ...filter };
    }
    setStates('drugWholeSaler', drugWholeSaler);
  };

  const updateWholeSalerSearch = (filter) => {
      drugWholeSaler.search.currentPage = filter.currentPage;
      drugWholeSaler.search.pageSize = filter.pageSize;
      drugWholeSaler.search.orderBy= filter.orderBy;
      drugWholeSaler.search.order= filter.order;
  }

  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setColumnFilters(columnFilters);
    }
    drugWholeSaler.search.currentPage=1;
    filterObj.currentPage=1;
    await fetchWholesalerAll(filterObj);
  };

  const handleSearchColumnFiltersClear = () => {
    setColumnFilters([]);
  };

 
  return (
    <div>
      <div  className="border-0">
        <Card className="border-0  shadow-top drug_tabs">
          <CardBody hidden={collapseSider}>
            <ErrorBoundary>
              <SearchContainer
                orgId={orgId}
                onSearch={handleSearch}
                onReset={handleReset}
                reset={reset}
                refetch={refetch}
                filters={search}
                collapseSider={collapseSider}
                toggleSider={toggleSider}

              />
            </ErrorBoundary>
          </CardBody>
          </Card>
          <Card className='border-0 mt-2 shadow-top'>
          <CardBody className="">
            {/* <div className="pt-0 text-center">
              <span
                style={{ fontSize: "27px", cursor: "pointer" }}
                onClick={toggleSider}
              >
                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
              </span>
            </div> */}
            <ErrorBoundary>
              <WholesalerTable
              fetchWholesalerAll={fetchWholesalerAll}
              accm={accm}
              orgId={orgId}
                data={data}
                onExport={handleExport}
                filters={search}
                totalitem={totalitem}
                refetch={refetch}
                onPageChange={handlePageChange}
                onSearchColumnFilters={handleSearchColumnFilters}
                onSearchColumnFiltersClear={handleSearchColumnFiltersClear}
                setAccountErr={setAccountErr}
                accuntErr ={accuntErr}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                 resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
                tabKey={tabKey}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default Wholsalers